var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { useUploadFileDirect } from '@office-start/upload-service';
import { UploadSource } from '@office-start/upload-types';
import { useCallback, useMemo } from 'react';
import { useDrop } from 'react-dnd';
import { NativeTypes } from 'react-dnd-html5-backend';
export var useDragAndDropUpload = function () {
    var uploadFile = useUploadFileDirect();
    var useDropCallback = useCallback(function () {
        return {
            accept: [NativeTypes.FILE],
            drop: function (item) {
                uploadFile({
                    area: 'Harmony',
                    file: item.files[0],
                    source: UploadSource.DragAndDrop,
                });
            },
            canDrop: function (item) {
                return item.items && item.items.length === 1;
            },
            collect: function (monitor) {
                return {
                    isOver: monitor.isOver(),
                    canDrop: monitor.canDrop(),
                };
            },
        };
    }, [uploadFile]);
    var _a = __read(useDrop(useDropCallback, [
        useDropCallback,
    ]), 2), _b = _a[0], canDrop = _b.canDrop, isOver = _b.isOver, connectDropTarget = _a[1];
    return useMemo(function () {
        return [canDrop && isOver, connectDropTarget];
    }, [canDrop, connectDropTarget, isOver]);
};
//# sourceMappingURL=useDragAndDropUpload.js.map